import React from "react";
import CouponsList from "./CouponsList";

const CouponsManagement = () => {
    return (
        <div className="coupons-management-container">
            <CouponsList />
        </div>
    );
};

export default CouponsManagement; 